import axios from 'axios';
import { HTTP_BASE_URL } from './http.constants';

export const HttpService = axios.create({
  baseURL: HTTP_BASE_URL,
  withCredentials: true,
});
